// Runtime settings, read from REACT_APP_* environment variables (see .env.example).
// Never put secrets here: everything in a React bundle is visible to users.

const env = process.env;
const bool = (v, fallback = false) => (v === undefined || v === '' ? fallback : v === 'true');
const num = (v, fallback) => (Number.isFinite(Number(v)) && v !== '' && v !== undefined ? Number(v) : fallback);

const isProduction = env.NODE_ENV === 'production';

// Backend (.NET API). `npm start` uses the local API, `npm run build` the Azure one.
// REACT_APP_API_BASE_URL in a .env file overrides both.
export const API_URLS = Object.freeze({
  local: 'https://localhost:7185/api', // Swagger: https://localhost:7185/swagger
  production: 'https://routebagapi-c0b7bjc7dghzh6b8.westus3-01.azurewebsites.net/api',
});

export const appConfig = Object.freeze({
  env: env.NODE_ENV,
  isProduction,

  api: Object.freeze({
    baseURL: (env.REACT_APP_API_BASE_URL || (isProduction ? API_URLS.production : API_URLS.local)).replace(/\/+$/, ''),
    timeoutMs: num(env.REACT_APP_API_TIMEOUT_MS, 20000),
    // Send cookies (httpOnly refresh token) with API requests.
    withCredentials: true,
    // Double-submit CSRF token: backend sets this cookie, axios echoes it in the header.
    xsrfCookieName: env.REACT_APP_XSRF_COOKIE || 'XSRF-TOKEN',
    xsrfHeaderName: env.REACT_APP_XSRF_HEADER || 'X-XSRF-TOKEN',
  }),

  auth: Object.freeze({
    // Sign out after this many minutes without user activity (0 disables).
    idleTimeoutMinutes: num(env.REACT_APP_IDLE_TIMEOUT_MINUTES, 30),
    // Refresh the access token this many seconds before it expires.
    refreshLeewaySeconds: 60,
    // Local demo accounts instead of the real auth API. Can never be on in a production build.
    // Always on under the test runner (tests sign in with the demo accounts).
    useMockAuth: !isProduction && (env.NODE_ENV === 'test' || bool(env.REACT_APP_USE_MOCK_API, false)),
  }),

  places: Object.freeze({
    dataURL: env.REACT_APP_PLACES_DATA_URL || 'https://pub-9b24add32f5740d88f5d4964aab0dedb.r2.dev/assets/Data',
    googleMapsKey: env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  }),
});

export default appConfig;
